import { TrendingUp, TrendingDown } from 'lucide-react'

export default function ImprovementScore({ score = 87, previousScore = 82 }) {
    const improvement = score - previousScore
    const circumference = 2 * Math.PI * 45 // radius = 45
    const progress = (score / 100) * circumference
    const offset = circumference - progress

    return (
        <div className="glass-card p-6 flex flex-col items-center">
            <h3 className="text-lg font-semibold text-white mb-6">Writing Quality Score</h3>

            {/* Circular Progress */}
            <div className="relative w-40 h-40 mb-6">
                <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
                    {/* Background circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke="rgba(255,255,255,0.1)"
                        strokeWidth="8"
                    />
                    {/* Progress circle */}
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        fill="none"
                        stroke="url(#scoreGradient)"
                        strokeWidth="8"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        className="transition-all duration-1000 ease-out"
                    />
                    {/* Gradient definition */}
                    <defs>
                        <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#22d3ee" />
                            <stop offset="100%" stopColor="#a855f7" />
                        </linearGradient>
                    </defs>
                </svg>

                {/* Score text */}
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <span className="text-4xl font-bold gradient-text">{score}</span>
                    <span className="text-sm text-white/50">out of 100</span>
                </div>
            </div>

            {/* Improvement indicator */}
            <div className={`flex items-center gap-2 px-4 py-2 rounded-full 
                      ${improvement >= 0 ? 'bg-green-500/20' : 'bg-red-500/20'}`}>
                {improvement >= 0 ? (
                    <TrendingUp className="w-4 h-4 text-green-400" />
                ) : (
                    <TrendingDown className="w-4 h-4 text-red-400" />
                )}
                <span className={`text-sm font-medium ${improvement >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                    {improvement >= 0 ? '+' : ''}{improvement} from last week
                </span>
            </div>

            {/* Score breakdown */}
            <div className="w-full mt-6 pt-6 border-t border-white/10 space-y-3">
                <div className="flex items-center justify-between">
                    <span className="text-sm text-white/60">Originality</span>
                    <div className="flex items-center gap-2">
                        <div className="w-24 h-2 rounded-full bg-white/10 overflow-hidden">
                            <div className="h-full bg-primary-400 rounded-full" style={{ width: '92%' }} />
                        </div>
                        <span className="text-sm text-white/80 w-8">92</span>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <span className="text-sm text-white/60">Clarity</span>
                    <div className="flex items-center gap-2">
                        <div className="w-24 h-2 rounded-full bg-white/10 overflow-hidden">
                            <div className="h-full bg-accent-400 rounded-full" style={{ width: '85%' }} />
                        </div>
                        <span className="text-sm text-white/80 w-8">85</span>
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <span className="text-sm text-white/60">Engagement</span>
                    <div className="flex items-center gap-2">
                        <div className="w-24 h-2 rounded-full bg-white/10 overflow-hidden">
                            <div className="h-full bg-ocean-400 rounded-full" style={{ width: '78%' }} />
                        </div>
                        <span className="text-sm text-white/80 w-8">78</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
